import { SvgIconProps } from "@mui/material";

export interface Project {
  id: number;
  name: string;
  description: string;
  type: string;
  technologies: string[];
  imageUrl: string[];
  githubUrl: string;
  projectLink: string;
  features?: string[];
}

export interface SocialLink {
  name: string;
  icon: React.ReactElement<SvgIconProps>;
  url: string;
  color:
    | "inherit"
    | "default"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning";
}

export interface Pages {
  menuTitle: string;
  pageURL: string;
  component: React.ReactNode;
}

export interface AboutProps {
  greeting: string;
  fullName: string;
  role: string;
  description: string[];
  socialLinks: {
    name: string;
    icon: JSX.Element;
    url: string;
  }[];
  profileImageUrl: string;
}

export interface ProjectDetailsDialogProps {
  open: boolean;
  handleClose: () => void;
  project: Project;
}

export interface ProjectCardProps {
  project: Project;
}

export interface DrawerProps {
  open: boolean;
  setDrawerOpen: (open: boolean) => void;
}

export interface MobileDrawerProps {
  open: boolean;
  onClose: () => void;
  pages: { menuTitle: string; pageURL: string }[];
}

export enum ViewModes {
  GRID = "grid",
  LIST = "list",
}

export interface Skill {
  src: string;
  alt: string;
}

export interface SkillsProps {
  skills: Skill[];
}

export interface NavigationLinksProps {
  pages: { menuTitle: string; pageURL: string }[];
}

export interface RTLWrapperProps {
  direction: "rtl" | "ltr";
  children: React.ReactNode;
}
